import axiosInstance from "./AxiosInstance";
import axiosInstanceFromCode from "./AxiosInstanceFromCode";

/**
 * Servicio para manejo de pre-registro de visitantes
 */
export class PreRegistroVisitantesService {
  /**
   * Consulta el servicio de pre-registro de visitantes por cédula
   * @param {string} cedula - Número de cédula del visitante
   * @returns {Promise} - Promesa que resuelve con los datos del visitante o null
   */
  static async getByIdentificacion(cedula) {
    try {
      const response = await axiosInstance.get(
        `/api/v3/vigilancia/pre-registro-visitantes/?cedula=${cedula}`,
      );

      if (response.data && response.data.length > 0) {
        return response.data[0];
      }
      return null;
    } catch (error) {
      // Error silencioso - no mostrar notificaciones al usuario
      console.warn("Error consultando pre-registro visitantes:", error);
      return null;
    }
  }
}

export class PreRegistroVisitantesVerificacionTelefonoService {
  static async getByTelefono(telefono, codigo) {
    try {
      const response = await axiosInstanceFromCode.get(
        `/api/v3/visitantes/pre-registro/inmuebles/validate-phone/`,
        {
          params: {
            codigo: codigo,
            numero: telefono,
          },
        },
      );

      const data = response.data;

      // Si el backend devuelve una lista (viejo comportamiento), devolvemos el primer elemento
      if (Array.isArray(data) && data.length > 0) {
        return data[0];
      }

      // Si el backend devuelve un objeto con la información de validación, lo devolvemos
      if (data && typeof data === "object") {
        return data;
      }

      return null;
    } catch (error) {
      // Error silencioso - no mostrar notificaciones al usuario
      console.warn(
        "Error consultando pre-registro visitantes por teléfono:",
        error,
      );
      return null;
    }
  }
}
